<div id="left-sidebar" class="sidebar-sticky h-100" style="width: 300px;">
    <div class="pl-4 d-flex flex-row">
        <div class="p-1">
            <img
                src="/assets/img/united-kingdom.png"
                [ngClass]="{ 'flag-selected': currentLangEnglish() }"
                class="flag-icon"
                alt=""
                (click)="setLanguageEnglish()"
            />
        </div>
        <div class="p-1">
            <img
                src="/assets/img/italy.png"
                [ngClass]="{ 'flag-selected': currentLangItalian() }"
                class="flag-icon"
                alt=""
                (click)="setLanguageItalian()"
            />
        </div>
        <div class="p-1">
            <img
                src="/assets/img/france.png"
                [ngClass]="{ 'flag-selected': currentLangFrench() }"
                class="flag-icon"
                alt=""
                (click)="setLanguageFrench()"
            />
        </div>
    </div>
    <div class="company-logo px-4">
        <img class="sidebar-logo d-block m-auto" src="assets/img/img_logo.png" />
    </div>
    <div class="d-flex flex-row justify-content-between px-4 pt-3">
        <div *ngIf="isInsideNursery && (isBack == null || !isBack)">
            <button (click)="onBackClick()" class="btn p-0 btn-back mb-2">
                <span><i class="fa fa-arrow-left pr-1"></i> {{ "HEADER_COMPONENT_LABEL_BACK" | translate }}</span>
            </button>
        </div>
        <div>
            <button (click)="onLogoutClick()" class="btn p-0 btn-back" style="right: 0;">
                <span><i class="fa fa-close pr-1"></i> {{ "HEADER_COMPONENT_LABEL_EXIT" | translate }}</span>
            </button>
        </div>
    </div>
    <div class="px-4 pt-2">
        <h4 *ngIf="isInsideNursery && nurseries.length > 0">{{ nurseries[0].name }}</h4>
        <form class="d-flex align-items-center position-relative">
            <input
                id="searchbar"
                class="searchbar w-100 px-2"
                type="text"
                name="search"
                autocomplete="off"
                [disabled]="nurseries.length <= 0"
                placeholder="{{ placeholder | translate }}"
                (keyup)="textChange()"
                (keydown.escape)="focusOut()"
                (keydown.enter)="onSearch()"
                [(ngModel)]="searchText"
            />
            <img
                class="close-img"
                src="assets/img/ic_close.svg"
                (click)="focusOut()"
                [hidden]="searchText === '' || searchText === undefined"
            />
        </form>
        <div class="entry-container pt-2" *ngIf="products && products.length > 0" style="padding-bottom: 100px;">
            <div *ngFor="let item of products">
                <div
                    *ngFor="let nursery of item.nurseries; let nurseryIndex = index"
                    (click)="itemClicked(item, nursery, nurseryIndex)"
                >
                    <div
                        *ngIf="
                            nursery &&
                            (isInsideNursery ||
                                (!isInsideNursery &&
                                    (getProdName(item).toUpperCase().includes(searchText.toUpperCase()) ||
                                        nursery.name.toUpperCase().includes(searchText.toUpperCase()))))
                        "
                        class="searchbar-entry w-100 p-2"
                    >
                        <span class="title-span d-block"
                            >{{ getProdName(item).toLowerCase() }}
                            {{
                                !isInsideNursery && nursery.name !== undefined && nursery.name !== null
                                    ? " - " + nursery.name
                                    : ""
                            }}</span
                        >
                        <span class="desc-span d-block">{{ "NURSERIES_CODE_LABEL" | translate }} {{ item.uuid }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="products == null || products.length == 0" class="p-2 pt-4" style="color: gray; font-size: 14px;">
            {{ emptySearchLabel | translate }}
        </div>
        <div class="bottom-section py-3 mt-auto text-right" style="position: fixed; bottom: 0;">
            <h5
                ><a href="mailto:{{ email }}">{{ "CONTACT_US_LABEL" | translate }}</a></h5
            >
            <h5
                ><a target="_blank" href="{{ faqUrl }}">{{ "FAQ_LABEL" | translate }}</a></h5
            >
        </div>
    </div>
</div>
